<template>
  <div>
    <main-header />
    <div class="daily-cargo-edit-filter">
      <br>
      <h1>{{ getRouteLabel(selectedRoute) }} </h1>
      <br>
      <h2>{{ dailyCargoData.Customer_Name }} - {{ dailyCargoData.Country_Name }} ({{ dailyCargoData.PostalCode_From }} - {{ dailyCargoData.PostalCode_To }})</h2>
      <br>
      <h3>Invoice Values</h3>
      <div class="daily-cargo-edit-filter__references">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>Invoiced Number of Parcels</form-label>
          <form-input
            v-model="dailyCargoData.Invoice_Nr_Parcels"
            :invalid="$v.dailyCargoData.Invoice_Nr_Parcels && $v.dailyCargoData.Invoice_Nr_Parcels.$invalid"
            placeholder="Invoiced Number of Parcels"
            data-cy="edit-daily-cargo-number-of-parcels" />
          <span v-if="$v.dailyCargoData.Invoice_Nr_Parcels && !$v.dailyCargoData.Invoice_Nr_Parcels.integer" class="error">Number of parcels has to be a number</span>
          <span v-if="$v.dailyCargoData.Invoice_Nr_Parcels && !$v.dailyCargoData.Invoice_Nr_Parcels.minValue" class="error">Number of parcels has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 2; grid-row: 1;">
          <form-label>Invoiced Weight</form-label>
          <form-input
            v-model="dailyCargoData.Invoice_Weight"
            :invalid="$v.dailyCargoData.Invoice_Weight && $v.dailyCargoData.Invoice_Weight.$invalid"
            placeholder="Invoiced Weight"
            data-cy="edit-daily-cargo-weight" />
          <span v-if="$v.dailyCargoData.Invoice_Weight && !$v.dailyCargoData.Invoice_Weight.decimal" class="error">Weight has to be a number</span>
          <span v-if="$v.dailyCargoData.Invoice_Weight && !$v.dailyCargoData.Invoice_Weight.minValue" class="error">Weight has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 3; grid-row: 1;">
          <form-label>Invoiced Volume</form-label>
          <form-input
            v-model="dailyCargoData.Invoice_Volume"
            :invalid="$v.dailyCargoData.Invoice_Volume && $v.dailyCargoData.Invoice_Volume.$invalid"
            placeholder="Invoiced Volume"
            data-cy="edit-daily-cargo-volume" />
          <span v-if="$v.dailyCargoData.Invoice_Volume && !$v.dailyCargoData.Invoice_Volume.decimal" class="error">Volume has to be a number</span>
          <span v-if="$v.dailyCargoData.Invoice_Volume && !$v.dailyCargoData.Invoice_Volume.minValue" class="error">Volume has to be bigger or equal to zero</span>
        </div>
      </div>
      <h3>Manifest Values</h3>
      <div class="daily-cargo-edit-filter__references">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>Number of Parcels</form-label>
          <form-input
            v-model="dailyCargoData.Nr_Parcels"
            :invalid="$v.dailyCargoData.Nr_Parcels && $v.dailyCargoData.Nr_Parcels.$invalid"
            placeholder="Number of Parcels"
            data-cy="edit-daily-cargo-number-of-parcels" />
          <span v-if="$v.dailyCargoData.Nr_Parcels && !$v.dailyCargoData.Nr_Parcels.integer" class="error">Number of parcels has to be a number</span>
          <span v-if="$v.dailyCargoData.Nr_Parcels && !$v.dailyCargoData.Nr_Parcels.minValue" class="error">Number of parcels has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 2; grid-row: 1;">
          <form-label>Weight</form-label>
          <form-input
            v-model="dailyCargoData.Weight"
            :invalid="$v.dailyCargoData.Weight && $v.dailyCargoData.Weight.$invalid"
            placeholder="Weight"
            data-cy="edit-daily-cargo-weight" />
          <span v-if="$v.dailyCargoData.Weight && !$v.dailyCargoData.Weight.decimal" class="error">Weight has to be a number</span>
          <span v-if="$v.dailyCargoData.Weight && !$v.dailyCargoData.Weight.minValue" class="error">Weight has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 3; grid-row: 1;">
          <form-label>Volume</form-label>
          <form-input
            v-model="dailyCargoData.Volume"
            :invalid="$v.dailyCargoData.Volume && $v.dailyCargoData.Volume.$invalid"
            placeholder="Volume"
            data-cy="edit-daily-cargo-volume" />
          <span v-if="$v.dailyCargoData.Volume && !$v.dailyCargoData.Volume.decimal" class="error">Volume has to be a number</span>
          <span v-if="$v.dailyCargoData.Volume && !$v.dailyCargoData.Volume.minValue" class="error">Volume has to be bigger or equal to zero</span>
        </div>
      </div>
      <h3>DGR Values</h3>
      <div class="daily-cargo-edit-filter__dgr_references">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>DGR Number of Parcels</form-label>
          <form-input
            v-model="dailyCargoData.DGR_Nr_Parcels"
            :invalid="$v.dailyCargoData.DGR_Nr_Parcels && $v.dailyCargoData.DGR_Nr_Parcels.$invalid"
            placeholder="DGR Number of Parcels"
            data-cy="edit-daily-cargo-dgr-number-of-parcels" />
          <span v-if="$v.dailyCargoData.DGR_Nr_Parcels && !$v.dailyCargoData.DGR_Nr_Parcels.integer" class="error">DGR number of parcels has to be a number</span>
          <span v-if="$v.dailyCargoData.DGR_Nr_Parcels && !$v.dailyCargoData.DGR_Nr_Parcels.minValue" class="error">DGR number of parcels has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 2; grid-row: 1;">
          <form-label>DGR Weight</form-label>
          <form-input
            v-model="dailyCargoData.DGR_Weight"
            :invalid="$v.dailyCargoData.DGR_Weight && $v.dailyCargoData.DGR_Weight.$invalid"
            placeholder="DGR Weight"
            data-cy="edit-daily-cargo-dgr-weight" />
          <span v-if="$v.dailyCargoData.DGR_Weight && !$v.dailyCargoData.DGR_Weight.decimal" class="error">DGR weight has to be a number</span>
          <span v-if="$v.dailyCargoData.DGR_Weight && !$v.dailyCargoData.DGR_Weight.minValue" class="error">DGR weight has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 3; grid-row: 1;">
          <form-label>DGR Volume</form-label>
          <form-input
            v-model="dailyCargoData.DGR_Volume"
            :invalid="$v.dailyCargoData.DGR_Volume && $v.dailyCargoData.DGR_Volume.$invalid"
            placeholder="DGR Volume"
            data-cy="edit-daily-cargo-dgr-volume" />
          <span v-if="$v.dailyCargoData.DGR_Volume && !$v.dailyCargoData.DGR_Volume.decimal" class="error">DGR volume has to be a number</span>
          <span v-if="$v.dailyCargoData.DGR_Volume && !$v.dailyCargoData.DGR_Volume.minValue" class="error">DGR volume has to be bigger or equal to zero</span>
        </div>
      </div>
      <h3>EQ Values</h3>
      <div class="daily-cargo-edit-filter__eq_references">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>EQ Number of Parcels</form-label>
          <form-input
            v-model="dailyCargoData.EQ_Nr_Parcels"
            :invalid="$v.dailyCargoData.EQ_Nr_Parcels && $v.dailyCargoData.EQ_Nr_Parcels.$invalid"
            placeholder="EQ Number of Parcels"
            data-cy="edit-daily-cargo-dgr-eq-number-of-parcels" />
          <span v-if="$v.dailyCargoData.EQ_Nr_Parcels && !$v.dailyCargoData.EQ_Nr_Parcels.integer" class="error">EQ number of parcels has to be a number</span>
          <span v-if="$v.dailyCargoData.EQ_Nr_Parcels && !$v.dailyCargoData.EQ_Nr_Parcels.minValue" class="error">EQ number of parcels has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 2; grid-row: 1;">
          <form-label>EQ Weight</form-label>
          <form-input
            v-model="dailyCargoData.EQ_Weight"
            :invalid="$v.dailyCargoData.EQ_Weight && $v.dailyCargoData.EQ_Weight.$invalid"
            placeholder="EQ Weight"
            data-cy="edit-daily-cargo-eq-weight" />
          <span v-if="$v.dailyCargoData.EQ_Weight && !$v.dailyCargoData.EQ_Weight.decimal" class="error">EQ weight has to be a number</span>
          <span v-if="$v.dailyCargoData.EQ_Weight && !$v.dailyCargoData.EQ_Weight.minValue" class="error">EQ weight has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 3; grid-row: 1;">
          <form-label>EQ Volume</form-label>
          <form-input
            v-model="dailyCargoData.EQ_Volume"
            :invalid="$v.dailyCargoData.EQ_Volume && $v.dailyCargoData.EQ_Volume.$invalid"
            placeholder="EQ Volume"
            data-cy="edit-daily-cargo-eq-volume" />
          <span v-if="$v.dailyCargoData.EQ_Volume && !$v.dailyCargoData.EQ_Volume.decimal" class="error">EQ volume has to be a number</span>
          <span v-if="$v.dailyCargoData.EQ_Volume && !$v.dailyCargoData.EQ_Volume.minValue" class="error">EQ volume has to be bigger or equal to zero</span>
        </div>
      </div>
      <h3>Dry Ice</h3>
      <div class="daily-cargo-edit-filter__dryice">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>1 Kg Dry Ice</form-label>
          <form-input
            v-model="dailyCargoData.Dry_Ice.Dry_Ice_1"
            :invalid="$v.dailyCargoData.Dry_Ice.Dry_Ice_1 && $v.dailyCargoData.Dry_Ice.Dry_Ice_1.$invalid"
            placeholder="1 Kg Dry Ice"
            data-cy="edit-daily-cargo-dry-ice-1kg" />
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_1 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_1.integer" class="error">Value has to be a number</span>
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_1 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_1.minValue" class="error">Value has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 2; grid-row: 1;">
          <form-label>4 Kg Dry Ice</form-label>
          <form-input
            v-model="dailyCargoData.Dry_Ice.Dry_Ice_4"
            :invalid="$v.dailyCargoData.Dry_Ice.Dry_Ice_4 && $v.dailyCargoData.Dry_Ice.Dry_Ice_4.$invalid"
            placeholder="4 Kg Dry Ice"
            data-cy="edit-daily-cargo--dry-ice-4kg" />
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_4 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_4.integer" class="error">Value has to be a number</span>
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_4 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_4.minValue" class="error">Value has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 3; grid-row: 1;">
          <form-label>7 Kg Dry Ice</form-label>
          <form-input
            v-model="dailyCargoData.Dry_Ice.Dry_Ice_7"
            :invalid="$v.dailyCargoData.Dry_Ice.Dry_Ice_7 && $v.dailyCargoData.Dry_Ice.Dry_Ice_7.$invalid"
            placeholder="7 Kg Dry Ice"
            data-cy="edit-daily-cargo--dry-ice-7kg" />
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_7 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_7.integer" class="error">Value has to be a number</span>
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_7 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_7.minValue" class="error">Value has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 4; grid-row: 1;">
          <form-label>9 Kg Dry Ice</form-label>
          <form-input
            v-model="dailyCargoData.Dry_Ice.Dry_Ice_9"
            :invalid="$v.dailyCargoData.Dry_Ice.Dry_Ice_9 && $v.dailyCargoData.Dry_Ice.Dry_Ice_9.$invalid"
            placeholder="9 Kg Dry Ice"
            data-cy="edit-daily-cargo--dry-ice-9kg" />
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_9 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_9.integer" class="error">Value has to be a number</span>
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_9 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_9.minValue" class="error">Value has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 5; grid-row: 1;">
          <form-label>12 Kg Dry Ice</form-label>
          <form-input
            v-model="dailyCargoData.Dry_Ice.Dry_Ice_12"
            :invalid="$v.dailyCargoData.Dry_Ice.Dry_Ice_12 && $v.dailyCargoData.Dry_Ice.Dry_Ice_12.$invalid"
            placeholder="12 Kg Dry Ice"
            data-cy="edit-daily-cargo--dry-ice-12kg" />
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_12 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_12.integer" class="error">Value has to be a number</span>
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_12 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_12.minValue" class="error">Value has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 6; grid-row: 1;">
          <form-label>19 Kg Dry Ice</form-label>
          <form-input
            v-model="dailyCargoData.Dry_Ice.Dry_Ice_19"
            :invalid="$v.dailyCargoData.Dry_Ice.Dry_Ice_19 && $v.dailyCargoData.Dry_Ice.Dry_Ice_19.$invalid"
            placeholder="19 Kg Dry Ice"
            data-cy="edit-daily-cargo--dry-ice-19kg" />
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_19 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_19.integer" class="error">Value has to be a number</span>
          <span v-if="$v.dailyCargoData.Dry_Ice.Dry_Ice_19 && !$v.dailyCargoData.Dry_Ice.Dry_Ice_19.minValue" class="error">Value has to be bigger or equal to zero</span>
        </div>
      </div>
      <h3>Offloaded Values</h3>
      <div class="daily-cargo-edit-filter__offloaded_references">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>Offloaded Number of Parcels</form-label>
          <form-input
            v-model="dailyCargoData.Offload_Nr_Parcels"
            :invalid="$v.dailyCargoData.Offload_Nr_Parcels && $v.dailyCargoData.Offload_Nr_Parcels.$invalid"
            placeholder="Offloaded Number of Parcels"
            data-cy="edit-daily-cargo-dgr-eq-number-of-parcels" />
          <span v-if="$v.dailyCargoData.Offload_Nr_Parcels && !$v.dailyCargoData.Offload_Nr_Parcels.integer" class="error">Offloaded number of parcels has to be a number</span>
          <span v-if="$v.dailyCargoData.Offload_Nr_Parcels && !$v.dailyCargoData.Offload_Nr_Parcels.minValue" class="error">Offloaded number of parcels has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 2; grid-row: 1;">
          <form-label>Offloaded Weight</form-label>
          <form-input
            v-model="dailyCargoData.Offload_Weight"
            :invalid="$v.dailyCargoData.Offload_Weight && $v.dailyCargoData.Offload_Weight.$invalid"
            placeholder="Offloaded Weight"
            data-cy="edit-daily-cargo-offload-weight" />
          <span v-if="$v.dailyCargoData.Offload_Weight && !$v.dailyCargoData.Offload_Weight.decimal" class="error">Offloaded weight has to be a number</span>
          <span v-if="$v.dailyCargoData.Offload_Weight && !$v.dailyCargoData.Offload_Weight.minValue" class="error">Offloaded weight has to be bigger or equal to zero</span>
        </div>
        <div style="grid-column: 3; grid-row: 1;">
          <form-label>Offloaded Volume</form-label>
          <form-input
            v-model="dailyCargoData.Offload_Volume"
            :invalid="$v.dailyCargoData.Offload_Volume && $v.dailyCargoData.Offload_Volume.$invalid"
            placeholder="Offloaded Volume"
            data-cy="edit-daily-cargo-offload-volume" />
          <span v-if="$v.dailyCargoData.Offload_Volume && !$v.dailyCargoData.Offload_Volume.decimal" class="error">Offloaded volume has to be a number</span>
          <span v-if="$v.dailyCargoData.Offload_Volume && !$v.dailyCargoData.Offload_Volume.minValue" class="error">Offloaded volume has to be bigger or equal to zero</span>
        </div>
      </div>
      <h3>EAD Value</h3>
      <div class="daily-cargo-edit-filter__ead_value">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>EAD Count</form-label>
          <form-input
            v-model="dailyCargoData.EAD_Count"
            :invalid="$v.dailyCargoData.EAD_Count && $v.dailyCargoData.EAD_Count.$invalid"
            placeholder="EAD Count"
            data-cy="edit-daily-cargo-ead-count" />
          <span v-if="$v.dailyCargoData.EAD_Count && !$v.dailyCargoData.EAD_Count.integer" class="error">EAD Value has to be a number</span>
          <span v-if="$v.dailyCargoData.EAD_Count && !$v.dailyCargoData.EAD_Count.minValue" class="error">EAD Value has to be bigger or equal to zero</span>
        </div>
      </div>
    </div>
    <daily-cargo-edit-action-bar
      :invalid="$v.$invalid"
      @onSave="handleSave"
      @onCancel="handleCancel" />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import MessageDialog from '@/components/shared/message-dialog'
import { create } from 'vue-modal-dialogs'
import Helpers from '@/helpers.vue'
import { integer, decimal, minValue } from 'vuelidate/lib/validators'
const messageDialog = create(MessageDialog, 'content')

export default {
  mixins: [Helpers],
  data () {
    return {
      routeLabel: '',
      dailyCargoData: {}
    }
  },
  validations () {
    return {
      dailyCargoData: {
        ...this.validatedFields,
        Dry_Ice: {
          ...this.validatedDryIceFields
        }
      }
    }
  },
  created () {
    this.dailyCargoData = this.$route.params
  },
  computed: {
    ...mapState('dailyCargo', ['selectedRoute', 'routeOptions']),
    validatedFields () {
      var fields = {}
      if (this.dailyCargoData.Nr_Parcels) {
        fields.Nr_Parcels = { integer, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Volume) {
        fields.Volume = { decimal, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Weight) {
        fields.Weight = { decimal, minValue: minValue(0) }
      }
      if (this.dailyCargoData.DGR_Nr_Parcels) {
        fields.DGR_Nr_Parcels = { integer, minValue: minValue(0) }
      }
      if (this.dailyCargoData.DGR_Volume) {
        fields.DGR_Volume = { decimal, minValue: minValue(0) }
      }
      if (this.dailyCargoData.DGR_Weight) {
        fields.DGR_Weight = { decimal, minValue: minValue(0) }
      }
      if (this.dailyCargoData.EQ_Nr_Parcels) {
        fields.EQ_Nr_Parcels = { integer, minValue: minValue(0) }
      }
      if (this.dailyCargoData.EQ_Volume) {
        fields.EQ_Volume = { decimal, minValue: minValue(0) }
      }
      if (this.dailyCargoData.EQ_Weight) {
        fields.EQ_Weight = { decimal, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Offload_Nr_Parcels) {
        fields.Offload_Nr_Parcels = { integer, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Offload_Weight) {
        fields.Offload_Weight = { decimal, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Offload_Volume) {
        fields.Offload_Volume = { decimal, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Invoice_Nr_Parcels) {
        fields.Invoice_Nr_Parcels = { integer, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Invoice_Weight) {
        fields.Invoice_Weight = { decimal, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Invoice_Volume) {
        fields.Invoice_Volume = { decimal, minValue: minValue(0) }
      }
      if (this.dailyCargoData.EAD_Count) {
        fields.EAD_Count = { integer, minValue: minValue(0) }
      }
      return fields
    },
    validatedDryIceFields () {
      var fields = {}
      if (this.dailyCargoData.Dry_Ice.Dry_Ice_1) {
        fields.Dry_Ice_1 = { integer, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Dry_Ice.Dry_Ice_4) {
        fields.Dry_Ice_4 = { integer, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Dry_Ice.Dry_Ice_7) {
        fields.Dry_Ice_7 = { integer, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Dry_Ice.Dry_Ice_9) {
        fields.Dry_Ice_9 = { integer, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Dry_Ice.Dry_Ice_12) {
        fields.Dry_Ice_12 = { integer, minValue: minValue(0) }
      }
      if (this.dailyCargoData.Dry_Ice.Dry_Ice_19) {
        fields.Dry_Ice_19 = { integer, minValue: minValue(0) }
      }
      return fields
    }
  },
  methods: {
    ...mapActions('dailyCargo', ['saveDailyCargo', 'loadDailyCargoData']),
    getRouteLabel (flightId) {
      return this.routeOptions.filter(route => route.value === flightId)[0].label
    },
    validateAndSend () {
      this.isLoading = true
      this.saveDailyCargo(this.dailyCargoData).then((response) => {
        this.isLoading = false
        this.loadDailyCargoData(this.dailyCargoData.Flight_ID)
        this.$router.push('/daily-cargo-general/6')
        this.$forceUpdate()
      }).catch((error) => {
        this.isLoading = false
        messageDialog('Something went wrong: ' + error.ExceptionMessage)
      })
    },
    // *********************** Handle Actionbar *************************
    handleSave () {
      this.validateAndSend()
    },
    handleCancel () {
      this.$router.push('/daily-cargo-general/6')
    }
  }
}
</script>
<style lang="scss">
  @import '../../../variables.scss';
  .daily-cargo-edit-filter {
    margin-bottom: 100px;
    margin: 0 70px;
    width: calc(100% - 138px);
    &__date {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-gap: 7px;
      width: 100%;

      &--active {
        background-color: $grey_80 !important;
      }

    }

    &__dryice {
      display: grid;
      grid-template-columns: 16% 16% 16% 16% 16% 16%;
      grid-gap: 6px;
      width: 100%;
    }

    &__ead_value {
      display: grid;
      grid-template-columns: 16% 16% 16% 16% 16% 16%;
      grid-gap: 6px;
      width: 100%;
    }

    &__references {
      display: grid;
      grid-template-columns: 32% 32% 32%;
      grid-gap: 7px;
      width: 100%;
    }
    &__dgr_references {
      display: grid;
      grid-template-columns: 32% 32% 32%;
      grid-gap: 7px;
      width: 100%;
    }
    &__eq_references {
      display: grid;
      grid-template-columns: 32% 32% 32%;
      grid-gap: 7px;
      width: 100%;
    }
    &__offloaded_references {
      display: grid;
      grid-template-columns: 32% 32% 32%;
      grid-gap: 7px;
      width: 100%;
    }
    &__dryice:last-child, &__references:last-child, &__eq_references:last-child, &__offloaded_references:last-child, &__dgr_references:last-child, &__ead_value:last-child {
      padding-bottom: 100px;
    }
  }
</style>
